'use strict';

var quickViewBase = require('../product/quickView');
var base = require('../product/base');

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 * @param {Boolean} updateRecommendationsProduct - Update recommendations product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    //
    base.updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update icons.
    base.updateIcons(response.product, $productContainer);
}

/**
 * updates the recommendation product view when a recommendation product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelectRecommendation(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelectRecommendation',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url     : selectedValueUrl,
            method  : 'GET',
            success : function (data) {
                handleVariantResponse(data, $productContainer);
                base.updateOptions(data.product.optionsHtml, $productContainer);
                base.updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger('product:afterAttributeSelectRecommendation',
                    { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Extended quickView without addToCart event. We make this change to avoid double events binded from PDP and Quickview recommendation used in PDP, when invoke addtocart
 */
module.exports = {
    showSpinner: function () {
        $('body').on('product:beforeAttributeSelectRecommendation', function () {
            $.spinner().start();
        });
    },
    selectRecommendationAttribute: function () {
        $(document).on('change', 'select[class*="selectrecommendation-"]', function (e) {
            e.preventDefault();
            var $productContainer = $(this).closest('.product-recommendation-detail');
            attributeSelectRecommendation(e.currentTarget.value, $productContainer);
        });
    },
    beforeUpdateAttribute: function () {
        $('body').on('product:beforeAttributeSelectRecommendation', function () {
            $('.modal.show .modal-content').spinner().start();
        });
    },
    updateAttributeRecommendation: function () {
        $('body').on('product:afterAttributeSelectRecommendation', function (e, response) {
            if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container)
                    .find('.product-recommendation-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-recommendation-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .view-details-link')
                    .attr('href', response.data.product.selectedProductUrl);
            }
        });
    },
    customRecommendationSelectSize: function () {
        $('body').on('touchstart click', '.js-recommendation-product-list-size', function () {
            var isSelected = $(this).hasClass('selected');
            if (isSelected) {
                return;
            }
            var size = $(this).attr('data-attr-value');
            $('.js-recommendation-product-list-size').removeClass('selected');
            $(this).addClass('selected');
            $('.selectrecommendation-size option').removeAttr('selected');
            $('.selectrecommendation-size option[data-attr-value="' + size + '"]').prop('selected', true);
            $('.selectrecommendation-size').trigger('change');
        });
    },
    showQuickview      : quickViewBase.showQuickview,
    hideDialog         : quickViewBase.hideDialog,
    updateAddToCart    : quickViewBase.updateAddToCart,
    updateAvailability : quickViewBase.updateAvailability,
    hideModalResize    : quickViewBase.hideModalResize
};
